import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router';

import useAppNavigate from '@/shared/hooks/useAppNavigation';
import { ROUTES } from '@/shared/routes';
import { getUserToken, removeUserToken } from '@/shared/services/user-hash';
import MainLoader from '@/shared/ui/main-loader';
import { useAppDispatch } from '@/store';
import { setIsAuth } from '@/store/auth.slice';
import { resetUserInfo } from '@/store/user-info.slice';

import AuthorizedProvider from './authorized.provider';

const ProtectedRoute: React.FC = () => {
  const dispatch = useAppDispatch();
  const { navigate } = useAppNavigate();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = getUserToken();
    if (!token?.accessToken) {
      removeUserToken();
      dispatch(setIsAuth(false));
      dispatch(resetUserInfo());
      navigate(`/${ROUTES.login}`, { replace: true });
    } else {
      setIsLoading(false);
    }
  }, [location.pathname]);

  if (isLoading) {
    return <MainLoader fullScreen />;
  }

  return (
    <AuthorizedProvider>
      <Outlet />
    </AuthorizedProvider>
  );
};

export default ProtectedRoute;
